import { useContext } from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { SynthesisScoreInfoArticle_ExamGradingResultFragment } from 'generated/graphql'
import PredictionTable from '@app.feature/exam/gsat2024-2/components/Table/PredictionTable'
import { TableColumnType } from '@app.feature/exam/gsat2024-2/components/Table/PredictionTableHead'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'

gql`
  fragment SynthesisScoreInfoArticle_examGradingResult on ExamGradingResult {
    viewerRank
    viewerRankOfSameInfo(type: $viewerRankOfSameInfoType2)
    viewerResult {
      answeredCount
      correctCount
      correctRate
      detail {
        answeredCount
        correctCount
        correctRate
        subject
      }
    }
  }
`

type PredictionTableDataType = {
  viewerRank: number
  viewerRankOfSameInfo: number
  viewerResult: Omit<
    SynthesisScoreInfoArticle_ExamGradingResultFragment['viewerResult'],
    'detail'
  >
}

const SynthesisScoreInfoArticleDesktop = () => {
  const { examGradingResultData } = useContext(
    PredictionOfPassedContainerContext,
  )

  const COLUMNS: TableColumnType<PredictionTableDataType>[] = [
    { id: '0', label: '구분', dataIndex: '구분' },
    {
      id: '1',
      label: '맞은 문항수 / 푼 문항수',
      dataIndex: 'correctRate',
      render: (data) => {
        return (
          <StyledTableData>
            <span>{data.viewerResult.correctCount}문항</span> /{' '}
            {data.viewerResult.answeredCount}문항
          </StyledTableData>
        )
      },
    },
    {
      id: '2',
      label: '정답률',
      dataIndex: 'correctPercentage',
      render: (data) => {
        const correctCount = data?.viewerResult.correctCount || 0
        const answeredCount = data.viewerResult.answeredCount || 0

        const avgCorrectRate =
          answeredCount > 0
            ? Math.round((correctCount / answeredCount) * 100)
            : 0

        return (
          <StyledTableData>
            <span>{avgCorrectRate}%</span>
          </StyledTableData>
        )
      },
    },
    {
      id: '3',
      label: '전체석차',
      dataIndex: 'viewerRank',
      render: (data) => {
        return (
          <StyledTableData>
            상위 <span>{data.viewerRank}%</span>
          </StyledTableData>
        )
      },
    },
    {
      id: '4',
      label: '동일 직무 내 석차',
      dataIndex: 'viewerRankOfSameInfo',
      render: (data) => {
        return (
          <StyledTableData className="bg-point">
            상위 <span>{data.viewerRankOfSameInfo}%</span>
          </StyledTableData>
        )
      },
    },
  ]

  const tableDataList = [
    {
      viewerResult: {
        answeredCount: examGradingResultData?.viewerResult.answeredCount || 0,
        correctCount: examGradingResultData?.viewerResult.correctCount || 0,
        correctRate: examGradingResultData?.viewerResult.correctRate || 0,
      },
      viewerRank: examGradingResultData?.viewerRank || 0,
      viewerRankOfSameInfo:
        examGradingResultData?.subsidiaryJobViewerRankOfSameInfo || 0,
    },
  ]

  return (
    <StyledWrapper>
      <PredictionTable<PredictionTableDataType>
        tableColumns={COLUMNS}
        tableDataList={tableDataList}
      />
    </StyledWrapper>
  )
}

export default SynthesisScoreInfoArticleDesktop

const StyledWrapper = styled.article`
  padding: 28px;
  border-radius: 10px;
  background-color: #fff;
`

const StyledTableData = styled.div`
  width: 100%;
  padding: 14px 0px;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: -0.64px;
  text-align: center;
  color: #333;

  > span {
    font-weight: bold;
    color: #004eff;
  }

  &.bg-point {
    background-color: #e5f5ff;
  }
`
